module.exports = __webpack_public_path__ + "img/A3-5-plan.03fe7c1b.png";